import React, {useEffect, useState} from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, {FreeMode, Scrollbar, Mousewheel} from 'swiper';

//import 'swiper/css';

//import "swiper/swiper-bundle.min.css";
//import './../../../../vendor/swiper/swiper-bundle.css';

// Import Swiper styles
//import "swiper/swiper.min.css";
//import "swiper/components/scrollbar/scrollbar.min.css"

import Card1 from './../../../../images/card/card1.jpg';
import Card2 from './../../../../images/card/card2.jpg';
// import Card3 from './../../../../images/card/card3.jpg';
// import Card4 from './../../../../images/card/card4.jpg';
import {useAccount, useBalance, useNetwork} from "wagmi";
import {DEFAULT_CHAIN, SWAP_CONTRACTS} from "../../../../chain/constants";
import {displayNumber} from "../../../../utils";
import Logo from "../../../../icons/logo.svg";

SwiperCore.use([FreeMode, Scrollbar, Mousewheel]);

// const swiperBlog = [
// 	{image: Card1, icon: <IconBlog1 />,},
// 	{image: Card2, icon: <IconBlog2 />,},
// 	{image: Card3, icon: <IconBlog2 />,},
// 	{image: Card4, icon: <IconBlog2 />,},
// 	{image: Card1, icon: <IconBlog1 />,},
// 	{image: Card2, icon: <IconBlog2 />,},
// 	{image: Card3, icon: <IconBlog2 />,},
// 	{image: Card4, icon: <IconBlog2 />,},
// ];

// function IconBlog1(){
// 	return(
// 		<>
// 			<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
// 				<path d="M19.2744 18.8013H16.0334V23.616H19.2744C19.9286 23.616 20.5354 23.3506 20.9613 22.9053C21.4066 22.4784 21.672 21.8726 21.672 21.1989C21.673 19.8813 20.592 18.8013 19.2744 18.8013Z" fill="white"/>
// 				<path d="M18 0C8.07429 0 0 8.07429 0 18C0 27.9257 8.07429 36 18 36C27.9257 36 36 27.9247 36 18C36 8.07531 27.9247 0 18 0ZM21.6627 26.3355H19.5398V29.6722H17.3129V26.3355H16.0899V29.6722H13.8528V26.3355H9.91954V24.2414H12.0898V11.6928H9.91954V9.59863H13.8528V6.3288H16.0899V9.59863H17.3129V6.3288H19.5398V9.59863H21.4735C22.5535 9.59863 23.5491 10.044 24.2599 10.7547C24.9706 11.4655 25.416 12.4611 25.416 13.5411C25.416 15.6549 23.7477 17.3798 21.6627 17.4744C24.1077 17.4744 26.0794 19.4647 26.0794 21.9096C26.0794 24.3453 24.1087 26.3355 21.6627 26.3355Z" fill="white"/>
// 				<path d="M20.7062 15.8441C21.095 15.4553 21.3316 14.9338 21.3316 14.3465C21.3316 13.1812 20.3842 12.2328 19.2178 12.2328H16.0334V16.4695H19.2178C19.7959 16.4695 20.3266 16.2226 20.7062 15.8441Z" fill="white"/>
// 			</svg>
// 		</>
// 	)
// }
// function IconBlog2(){
// 	return(
// 		<>
// 			<svg width="55" height="34" viewBox="0 0 55 34" fill="none" xmlns="http://www.w3.org/2000/svg">
// 				<circle cx="38.0091" cy="16.7788" r="16.7788" fill="white" fillOpacity="0.67"/>
// 				<circle cx="17.4636" cy="16.7788" r="16.7788" fill="white" fillOpacity="0.67"/>
// 			</svg>
// 		</>
// 	)
// }

function IconDWT(){
	return(
		<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 36, height: 36, background: 'white', borderRadius: 18 }}>
			<img width="24" height="24" src={Logo} alt="" />
		</div>
	)
}

function IconUSDC(){
	return(
		<>
			<svg width="36" height="36" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clip-path="url(#clip0_470_2)">
					<path d="M32 64C49.7334 64 64 49.7334 64 32C64 14.2666 49.7334 0 32 0C14.2666 0 0 14.2666 0 32C0 49.7334 14.2666 64 32 64Z" fill="white"/>
					<path d="M40.8002 37.0666C40.8002 32.4 38.0002 30.8 32.4002 30.1335C28.4002 29.6 27.6002 28.5335 27.6002 26.6666C27.6002 24.7997 28.9336 23.6 31.6002 23.6C34.0002 23.6 35.3336 24.4 36.0002 26.4C36.1336 26.8 36.5336 27.0666 36.9336 27.0666H39.0667C39.6002 27.0666 40.0002 26.6666 40.0002 26.1335V26C39.4667 23.0666 37.0667 20.8 34.0002 20.5335V17.3335C34.0002 16.8 33.6002 16.4 32.9336 16.2666H30.9336C30.4002 16.2666 30.0002 16.6666 29.8667 17.3335V20.4C25.8667 20.9335 23.3336 23.6 23.3336 26.9335C23.3336 31.3335 26.0002 33.0666 31.6002 33.7335C35.3336 34.4 36.5336 35.2 36.5336 37.3335C36.5336 39.4669 34.6667 40.9335 32.1336 40.9335C28.6667 40.9335 27.4667 39.4666 27.0667 37.4666C26.9336 36.9335 26.5336 36.6666 26.1336 36.6666H23.8667C23.3336 36.6666 22.9336 37.0666 22.9336 37.6V37.7335C23.4667 41.0666 25.6002 43.4666 30.0002 44.1335V47.3335C30.0002 47.8666 30.4002 48.2666 31.0667 48.4H33.0667C33.6002 48.4 34.0002 48 34.1336 47.3335V44.1335C38.1336 43.4666 40.8002 40.6666 40.8002 37.0666Z" fill="#E68258"/>
					<path d="M25.2002 51.0666C14.8002 47.3335 9.46672 35.7335 13.3336 25.4666C15.3336 19.8666 19.7336 15.6001 25.2002 13.6001C25.7336 13.3335 26.0002 12.9335 26.0002 12.2666V10.4001C26.0002 9.86662 25.7336 9.46662 25.2002 9.3335C25.0667 9.3335 24.8002 9.3335 24.6667 9.46662C12.0002 13.4666 5.06672 26.9335 9.06672 39.6001C11.4667 47.0666 17.2002 52.8001 24.6667 55.2001C25.2002 55.4666 25.7336 55.2001 25.8667 54.6666C26.0002 54.5335 26.0002 54.4001 26.0002 54.1335V52.2666C26.0002 51.8666 25.6002 51.3335 25.2002 51.0666ZM39.3336 9.46662C38.8002 9.20006 38.2667 9.46662 38.1336 10.0001C38.0002 10.1335 38.0002 10.2666 38.0002 10.5335V12.4001C38.0002 12.9335 38.4002 13.4666 38.8002 13.7335C49.2002 17.4666 54.5336 29.0666 50.6667 39.3335C48.6667 44.9335 44.2667 49.2001 38.8002 51.2001C38.2667 51.4666 38.0002 51.8666 38.0002 52.5335V54.4001C38.0002 54.9335 38.2667 55.3335 38.8002 55.4666C38.9336 55.4666 39.2002 55.4666 39.3336 55.3335C52.0002 51.3335 58.9336 37.8666 54.9336 25.2001C52.5336 17.6001 46.6667 11.8666 39.3336 9.46662Z" fill="#E68258"/>
				</g>
				<defs>
					<clipPath id="clip0_470_2">
						<rect width="64" height="64" fill="white"/>
					</clipPath>
				</defs>
			</svg>
		</>
	)
}

function BalanceSlider({ data }) {
	const { data: balance } = useBalance({
		address: data.account,
		chainId: data.token.chainId,
		formatUnits: data.token.decimals,
		token: data.token.address,
		watch: true,
		enabled: !!data.token && data.account,
	});
	// useEffect(() => console.log(balance), [balance]);

	return (
		<div className="card-bx stacked card">
			<img src={data.image} alt="" />
			<div className="card-info">
				<p className="mb-1 text-white fs-14">{data.title}</p>
				<div className="d-flex justify-content-between">
					<h2 className="num-text text-white mb-5 font-w600">{displayNumber(balance?.formatted)}</h2>
					{data.icon}
				</div>
				<div className="d-flex">
					<div className="me-4 text-white">
						<p className="fs-12 mb-1 op6">Decimals</p>
						<span>{data.token.decimals}</span>
					</div>
					<div className="text-white">
						<p className="fs-12 mb-1 op6">Name</p>
						<span>{data.token.name}</span>
					</div>
				</div>
			</div>
		</div>
	);
}

export default function SwiperSlider2() {
	const { address, isConnected } = useAccount();
	const { chain, chains } = useNetwork();

	const [swiperBlog, setSwiperBlog] = useState([]);
	useEffect(() => {
		let chainId = DEFAULT_CHAIN.id;
		if (isConnected && chain?.id && chains.findIndex(c => c.id === chain.id) > -1) {
			chainId = chain.id;
		}
		if (chainId in SWAP_CONTRACTS) {
			setSwiperBlog([
				{
					image: Card1,
					icon: <IconDWT />,
					token: SWAP_CONTRACTS[chainId].v2Token,
					account: address,
					title: `${SWAP_CONTRACTS[chainId].v2Token?.symbol} Balance`,
				},
				{
					image: Card2,
					icon: <IconUSDC />,
					token: SWAP_CONTRACTS[chainId].v1Token,
					account: address,
					title: `${SWAP_CONTRACTS[chainId].v1Token?.symbol} Balance`,
				},
			]);
		} else {
			setSwiperBlog([]);
		}
	}, [address, isConnected, chain, chains]);

	// useEffect(() => console.log('swiperBlog', swiperBlog), [swiperBlog]);

  return (
    <>
    <Swiper direction={'vertical'} slidesPerView={'auto'} freeMode={true} scrollbar={true} mousewheel={true} 
		modules={[FreeMode, Scrollbar, Mousewheel]}
		breakpoints={{
			360: {
				direction: 'horizontal',
				slidesPerView: 'auto',
				
			},
			650: {
				direction: 'horizontal',
				slidesPerView: 2,
				scrollbar: {
					"el": '.swiper-scrollbar',
					
				},
			},
			1200: {
				direction: 'vertical',
				slidesPerView: 'auto',
				scrollbar: {
					el: '.swiper-scrollbar',
				},
			},			
		}}
		className="mySwiper swiper-container card-swiper"
	>
				{swiperBlog.map((data,index)=>(	
					<SwiperSlide  key={index}>
						<BalanceSlider data={data}/>
					</SwiperSlide>
				))}
		</Swiper>
    </>
  )
}